import retrieveBookingAuthenticationMethod from './retrieveBookingAuthenticationMethod';
import sbaAuthentication from './sbaAuthentication';
import sbaAuthenticationUpdate from './sbaAuthenticationUpdate';
import sbaAuthenticationRemove from './sbaAuthenticationRemove';
import monitorTokenExpiry from '../sba/logic/monitorTokenExpiry';
import setQffAuthenticationCookie from '../sso/logic/setQffAuthenticationCookie';

const logic = [
  retrieveBookingAuthenticationMethod,
  sbaAuthentication,
  sbaAuthenticationUpdate,
  sbaAuthenticationRemove,
  monitorTokenExpiry,
  setQffAuthenticationCookie,
];

export default logic;
